import { SCAN_UNAVAILABLE_MESSAGE } from "@via/utils/scan";
import type { JSX } from "react";

/** What /scan and /a/<code> show when the v2 metadata interface is off. */
export default function ScanUnavailable(): JSX.Element {
  return (
    <main className="p-4">
      <p className="text-sm text-gray-700">{SCAN_UNAVAILABLE_MESSAGE}</p>
    </main>
  );
}
